export default {
  host: process.env.VUE_APP_MICROSERVICE_API_UBICACIONES || "",
};
